import React from "react";
import { ShieldCheck } from "lucide-react";
import { Reveal } from "../Reveal";
import { useLang } from "../../i18n/LanguageContext";
import { siteConfig } from "../../content/siteConfig";

export const Quality = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#DFF7F5]/40 py-28 md:py-36 border-t border-black/5" data-testid="home-quality">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-12">
        <Reveal className="md:col-span-5">
          <ShieldCheck size={28} strokeWidth={1.5} className="text-[#19C7C1]" />
          <p className="eyebrow-dark mt-8">{t.quality.eyebrow}</p>
          <h2 className="mt-5 text-3xl md:text-4xl font-light tracking-tight text-[#061A26] leading-[1.15]">
            {t.quality.title}
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-6 md:col-start-7 flex flex-col justify-center">
          <p className="text-base text-slate-700 leading-relaxed">{t.quality.copy}</p>
          {siteConfig.certifications.length === 0 && (
            <p className="mt-8 text-xs text-slate-500 border border-dashed border-slate-300 p-5 leading-relaxed" data-testid="quality-cert-placeholder">
              {t.quality.placeholder}
            </p>
          )}
        </Reveal>
      </div>
    </section>
  );
};
